import { Component, Input } from '@angular/core'
import { GrauSatisfacaoDomainModel } from '@shared/models/backend'
import { FormFieldComponent } from '@widgets/form-field/form-field.component'

@Component({
  selector: 'app-satisfacao-picker-button',
  templateUrl: './picker-button.component.html',
  styleUrls: ['./picker-button.component.scss'],
})
export class PickerButtonComponent {
  satisfacaoModel: GrauSatisfacaoDomainModel

  @Input()
  parentSelectedOption: GrauSatisfacaoDomainModel

  @Input()
  tooltip: string

  @Input()
  matIcon: string

  @Input()
  grau: number

  get selected(): boolean {
    return this?.parentSelectedOption?.id == this?.grau
  }

  get buttonColor(): string {
    return this.selected ? 'rgb(38, 166, 154)' : 'rgba(0, 0, 0, 0.87)'
  }
}
